import { Component } from '@angular/core';

@Component({
  templateUrl: './error404.component.html'
})
export class Error404Component {

}
